import React from 'react';
import { unescapeChars } from '@crehana/ui';

import type { CourseCardProps } from '../../types';

const Professor: React.FC<Partial<CourseCardProps>> = props => {
  const { professor } = props;

  return (
    <p className="ProfessorComponent font-body4 text-base-main mb-8 lg:mb-0 min-h-40">
      {`Por ${professor ? unescapeChars(professor.fullName!) : 'crehana'}`}
    </p>
  );
};

export default Professor;
